<div class="main-content">
  <div class="main-heading">
    <strong *ngIf="isAdmin" translate>ABOUT_SYSTEM</strong>
    <strong *ngIf="!isAdmin" translate>CUSTOMIZE_DASHBOARD</strong>
  </div>
  <!-- One editor serving two roles. An Admin is left with a single tab, the
       "About the system" content shown in the dashboard widget of every
       business that has that feature enabled; the other Admin CMS tabs
       (About us, Contact us, Services, Products, Dashboard Text, Help,
       About) were removed - none of them reached a customer. A Portal
       still maintains its own logo and news. -->
  <p class="text-muted" *ngIf="isAdmin" translate>ABOUT_SYSTEM_DESCRIPTION</p>
  <div class="panel-tabs">
    <nav>
      <ul class="nav nav-pills" *ngIf="isAdmin">
        <li role="presentation" class="active">
          <a (click)="changeNavigation(51)" href="javascript:void(0)"
            >{{ "ABOUT" | translate }} {{ applicationName }}</a
          >
        </li>
      </ul>
      <ul class="nav nav-pills" *ngIf="!isAdmin">
        <li
          role="presentation"
          class="{{ logoclass }}"
          routerLinkActive="active"
        >
          <a
            (click)="changeNavigation(56)"
            routerLink="./add"
            href="javascript:void(0)"
            translate
            >LOGO</a
          >
        </li>
        <li role="presentation" routerLinkActive="active">
          <a
            (click)="changeNavigation(57)"
            routerLink="./customize-news"
            href="javascript:void(0)"
            translate
            >NEWS</a
          >
        </li>
      </ul>
    </nav>
  </div>
  <div class="card">
    <div class="card-body">
      <form class="form-horizontal" [formGroup]="HomepageForm">
        <div class="upload-file-container" *ngIf="portalLogo">
          <div class="form-group">
            <div class="upload-actions">
              <input
                type="file"
                id="uploadimage"
                class="hidden"
                (change)="filesSelect($event)"
              />
              <label for="uploadimage" class="btn btn-outline-primary" translate
                >UPLOAD_IMAGE</label
              >
            </div>
            <div *ngIf="uploadStart">
              <span translate>IMAGE_IS_UPLOADING</span>
            </div>
            <div *ngIf="logo != null">
              <img src="{{ logo }}" alt="" width="100" height="100" />
            </div>
          </div>
        </div>
        <div *ngIf="toggleTextEditorTab">
          <p-editor
            formControlName="ContentData"
            [style]="{ height: '320px' }"
          ></p-editor>
        </div>
      </form>
      <div class="action-btns-wrapper">
        <button class="btn btn-outline-secondary" (click)="clear()" translate>
          CLEAR
        </button>
        <button class="btn btn-primary" (click)="saveData()" translate>
          SAVE
        </button>
        <button class="btn btn-secondary" (click)="back()" translate>
          BACK
        </button>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog
  header="{{ 'CONFIRMATION' | translate }}"
  icon="pi pi-question-circle"
  width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}"
  rejectLabel="{{ 'SWITCH_NO' | translate }}"
></p-confirmDialog>
